export const trackEvent = (eventName: string, eventProperties: any) => {
  eventProperties = eventProperties || {};

  window.parent.postMessage(
    JSON.stringify({ type: eventName, ...eventProperties }),
    "*"
  );
};
